// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-button {
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  background: #ffffff;
  border: none;
  margin: 0px 6px;
  border-bottom: none;
  cursor: pointer;
}

.horizontal-rule {
  width: 184px;
  height: 0px;
  border: 1px solid #cccccc;
}

.arrow-up {
  color: #cc0000;
  width: 16px;
  height: 16px;
}

.visited-row {
  color: purple !important;
}

.arabic-table {
  background: #ffffff;
  gap: 1px;
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  table-layout: fixed;
}

.results-layout {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-left: 1rem;
  margin-right: 1rem;
}

.results-table-col {
  flex: 1 1;
  min-width: 0;
}

.desktop-left-pane {
  margin-left: 60px;
  max-width: 20%;
}

.arabic-table-container {
  width: 100%;
  overflow-x: hidden;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  direction: rtl;
}

.search-res-group {
  margin-left: 0;
  width: 100%;
}

.table-horizontal-rule {
  border-bottom: 1px solid #e5e5e5;
}

.arabic-title-text {
  font-size: large;
  font-weight: bold;
  font-family: "Roboto Slab";
  color: #12394d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}

.arabic-table-head {
  font-family: "Roboto";
  font-style: normal;
  /* color: #666666; */
  color: #12394d;
  border-bottom: 1px solid #e5e5e5;
  vertical-align: middle;
  direction: rtl;
}

.arabic-table-th {
  direction: rtl;
  color: #12394d;
  padding: 8px;
}

.arabic-table-th-2 {
  margin-top: 5px;
  padding-top: 18px;
  padding-bottom: 15px;
  vertical-align: middle;
  font-weight: 10;
}

.arabic-ellipsis,
.arabic-ellipsis2 {
  max-width: 100%;
  padding: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  direction: rtl;
}

.filters {
  display: none;
}

.analytics-button {
  border: 2px solid #1a1a1a;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  width: 130px;
  background-color: #e5e5e5;
}

.filter-button {
  border: 2px solid #cc0000;
  color: #cc0000;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  width: 130px;
  background-color: #e5e5e5;
}

.modal-title-style-arabic {
  margin: 0;
  padding: 12px;
  font-weight: 700;
  font-size: 30px;
  color: #12394d;
}

.modal-body > .left-pane-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.rag-summary {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(18, 57, 77, 0.12);
  margin: 24px auto 0;
  width: min(90%, 860px);
  padding: 20px 28px;
  direction: rtl;
  text-align: right;
}

.rag-summary h4 {
  font-family: "Roboto Slab";
  font-size: 20px;
  margin: 0 0 10px;
  color: #12394d;
}

.rag-summary p {
  margin: 0;
  font-family: "Roboto";
  font-size: 16px;
  line-height: 1.6;
  color: #1a1a1a;
  white-space: pre-wrap;
}

@media (max-width: 1024px) {
  .left-pane {
    display: none;
  }

  .filters {
    display: flex;
    justify-content: space-around;
  }

  .results-layout {
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 992px) {
  .results-table-col {
    flex-basis: 100%;
  }
}

@media (max-width: 768px) {
  .arabic-table-container table,
  .arabic-table-container thead,
  .arabic-table-container tbody,
  .arabic-table-container th,
  .arabic-table-container td,
  .arabic-table-container tr {
    display: block;
  }

  .arabic-table-container thead {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .desktop-left-pane {
    display: none;
  }

  .results-table-col {
    flex-basis: 100%;
  }

  .arabic-table-container tr {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 18px;
    border: 1px solid #e5e5e5;
    border-radius: 12px;
    padding: 18px 20px;
    background: #ffffff;
    box-shadow: 0 8px 18px rgba(18, 57, 77, 0.08);
  }

  .arabic-table thead th {
    font-size: 0.85rem;
    padding: 12px 8px;
  }

  .arabic-table td {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    width: 100%;
    padding: 18px 0 0;
    border: none;
    font-size: 0.95rem;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    text-align: right;
  }

  .arabic-table td:not(:last-child) {
    padding-bottom: 16px;
    border-bottom: 1px solid #f1f1f1;
  }

  .arabic-table td::before {
    content: attr(data-label);
    position: absolute;
    top: 0;
    right: 0;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #7c8a96;
  }

  .arabic-table td img {
    margin-left: 10px;
    margin-right: 0;
  }

  .arabic-table td:last-child {
    padding-bottom: 4px;
  }

  .arabic-title-text,
  .arabic-ellipsis,
  .arabic-ellipsis2 {
    white-space: normal;
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles-arabic/search-results.rtl.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;;;IAME,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;EAC/C;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":[".pagination-button {\n  box-sizing: border-box;\n  width: 36px;\n  height: 36px;\n  background: #ffffff;\n  border: none;\n  margin: 0px 6px;\n  border-bottom: none;\n  cursor: pointer;\n}\n\n.horizontal-rule {\n  width: 184px;\n  height: 0px;\n  border: 1px solid #cccccc;\n}\n\n.arrow-up {\n  color: #cc0000;\n  width: 16px;\n  height: 16px;\n}\n\n.visited-row {\n  color: purple !important;\n}\n\n.arabic-table {\n  background: #ffffff;\n  gap: 1px;\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  table-layout: fixed;\n}\n\n.results-layout {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.results-table-col {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.desktop-left-pane {\n  margin-left: 60px;\n  max-width: 20%;\n}\n\n.arabic-table-container {\n  width: 100%;\n  overflow-x: hidden;\n  background: #ffffff;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  direction: rtl;\n}\n\n.search-res-group {\n  margin-left: 0;\n  width: 100%;\n}\n\n.table-horizontal-rule {\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.arabic-title-text {\n  font-size: large;\n  font-weight: bold;\n  font-family: \"Roboto Slab\";\n  color: #12394d;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.arabic-table-head {\n  font-family: \"Roboto\";\n  font-style: normal;\n  /* color: #666666; */\n  color: #12394d;\n  border-bottom: 1px solid #e5e5e5;\n  vertical-align: middle;\n  direction: rtl;\n}\n\n.arabic-table-th {\n  direction: rtl;\n  color: #12394d;\n  padding: 8px;\n}\n\n.arabic-table-th-2 {\n  margin-top: 5px;\n  padding-top: 18px;\n  padding-bottom: 15px;\n  vertical-align: middle;\n  font-weight: 10;\n}\n\n.arabic-ellipsis,\n.arabic-ellipsis2 {\n  max-width: 100%;\n  padding: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n  direction: rtl;\n}\n\n.filters {\n  display: none;\n}\n\n.analytics-button {\n  border: 2px solid #1a1a1a;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  width: 130px;\n  background-color: #e5e5e5;\n}\n\n.filter-button {\n  border: 2px solid #cc0000;\n  color: #cc0000;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  width: 130px;\n  background-color: #e5e5e5;\n}\n\n.modal-title-style-arabic {\n  margin: 0;\n  padding: 12px;\n  font-weight: 700;\n  font-size: 30px;\n  color: #12394d;\n}\n\n.modal-body > .left-pane-modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rag-summary {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 12px 24px rgba(18, 57, 77, 0.12);\n  margin: 24px auto 0;\n  width: min(90%, 860px);\n  padding: 20px 28px;\n  direction: rtl;\n  text-align: right;\n}\n\n.rag-summary h4 {\n  font-family: \"Roboto Slab\";\n  font-size: 20px;\n  margin: 0 0 10px;\n  color: #12394d;\n}\n\n.rag-summary p {\n  margin: 0;\n  font-family: \"Roboto\";\n  font-size: 16px;\n  line-height: 1.6;\n  color: #1a1a1a;\n  white-space: pre-wrap;\n}\n\n@media (max-width: 1024px) {\n  .left-pane {\n    display: none;\n  }\n\n  .filters {\n    display: flex;\n    justify-content: space-around;\n  }\n\n  .results-layout {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n@media (max-width: 992px) {\n  .results-table-col {\n    flex-basis: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .arabic-table-container table,\n  .arabic-table-container thead,\n  .arabic-table-container tbody,\n  .arabic-table-container th,\n  .arabic-table-container td,\n  .arabic-table-container tr {\n    display: block;\n  }\n\n  .arabic-table-container thead {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  .desktop-left-pane {\n    display: none;\n  }\n\n  .results-table-col {\n    flex-basis: 100%;\n  }\n\n  .arabic-table-container tr {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 18px;\n    border: 1px solid #e5e5e5;\n    border-radius: 12px;\n    padding: 18px 20px;\n    background: #ffffff;\n    box-shadow: 0 8px 18px rgba(18, 57, 77, 0.08);\n  }\n\n  .arabic-table thead th {\n    font-size: 0.85rem;\n    padding: 12px 8px;\n  }\n\n  .arabic-table td {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px;\n    width: 100%;\n    padding: 18px 0 0;\n    border: none;\n    font-size: 0.95rem;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: clip;\n    text-align: right;\n  }\n\n  .arabic-table td:not(:last-child) {\n    padding-bottom: 16px;\n    border-bottom: 1px solid #f1f1f1;\n  }\n\n  .arabic-table td::before {\n    content: attr(data-label);\n    position: absolute;\n    top: 0;\n    right: 0;\n    font-size: 0.7rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: #7c8a96;\n  }\n\n  .arabic-table td img {\n    margin-left: 10px;\n    margin-right: 0;\n  }\n\n  .arabic-table td:last-child {\n    padding-bottom: 4px;\n  }\n\n  .arabic-title-text,\n  .arabic-ellipsis,\n  .arabic-ellipsis2 {\n    white-space: normal;\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
